module.exports = __webpack_public_path__ + "img/L1020139.8d30c5c8.jpg";